(() => {
  const root = window.Shopify?.routes?.root || '/';
  const labels = JSON.parse(document.getElementById('AtLabels')?.textContent || '{}');
  const t = key => labels[key] || key;
  let cartBusy = false;
  let cartOpener;
  const dialog = () => document.getElementById('AlfuzonCart');
  const cartPageSection = () => document.querySelector('[data-at-cart-page]')?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
  const sectionNames = () => ['at-cart', cartPageSection()].filter(Boolean);
  const request = async (path, options = {}) => {
    const response = await fetch(root + path, {credentials: 'same-origin', ...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || t('error'));
    return data;
  };
  const renderCart = sections => {
    if (!sections?.['at-cart']) return false;
    const parsed = new DOMParser().parseFromString(sections['at-cart'], 'text/html');
    const incoming = parsed.querySelector('[data-at-cart-content]');
    const current = dialog()?.querySelector('[data-at-cart-content]');
    if (!incoming || !current) return false;
    current.replaceWith(incoming);
    document.querySelectorAll('[data-rf-cart-count]').forEach(el => {
      el.textContent = incoming.dataset.count;
      el.hidden = Number(incoming.dataset.count) === 0;
    });
    const pageId = cartPageSection();
    if (pageId && sections[pageId]) {
      const page = new DOMParser().parseFromString(sections[pageId], 'text/html').querySelector('[data-at-cart-page]');
      if (page) document.querySelector('[data-at-cart-page]').replaceWith(page);
    }
    return true;
  };
  const refreshCart = async () => {
    const response = await fetch(root + '?sections=' + sectionNames().join(','), {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    if (!response.ok || !renderCart(await response.json())) throw new Error(t('update_error'));
    const error = dialog()?.querySelector('[data-at-cart-error]');
    if (error) error.textContent = '';
  };
  const openCart = () => {
    const el = dialog();
    if (!el || el.open) return;
    cartOpener = document.activeElement;
    el.showModal();
    document.body.classList.add('at-cart-open');
    el.querySelector('[data-at-cart-close]')?.focus();
  };
  const closeCart = () => {
    const feedback = dialog()?.querySelector('[data-at-cart-feedback]');
    if (feedback) feedback.textContent = '';
    dialog()?.close();
    document.body.classList.remove('at-cart-open');
    if (cartOpener?.isConnected) cartOpener.focus();
  };
  const showCartError = error => {
    const el = dialog()?.querySelector('[data-at-cart-error]');
    if (el) el.textContent = error.message || t('error');
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.at-product-form,.rf-product-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.atPending === 'true') return;
    const buy = event.submitter?.hasAttribute('data-at-buy');
    const fromCart = Boolean(form.closest('#AlfuzonCart'));
    const button = event.submitter || form.querySelector('[name="add"]');
    if (button?.disabled) return;
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    const state = buttons.map(el => ({el, label: el.textContent, disabled: el.disabled}));
    const message = form.querySelector('[role="status"]');
    const data = new FormData(form);
    data.delete('pack_choice');
    data.set('sections', sectionNames().join(','));
    data.set('sections_url', root + 'cart');
    form.dataset.atPending = 'true';
    buttons.forEach(el => {el.disabled = true;});
    if (button) button.textContent = t('adding');
    if (message) message.textContent = '';
    try {
      const added = await request('cart/add.js', {method: 'POST', body: data, headers: {Accept: 'application/json'}});
      if (buy) {window.location.assign(root + 'checkout'); return;}
      if (!renderCart(added.sections)) await refreshCart();
      if (message) message.textContent = t('added');
      openCart();
      if (fromCart) {
        const feedback = dialog()?.querySelector('[data-at-cart-feedback]');
        if (feedback) feedback.textContent = t('added');
        dialog()?.querySelector('[data-at-cart-close]')?.focus();
      }
    } catch (error) {
      if (message) message.textContent = error.message;
      if (fromCart) showCartError(error);
    } finally {
      form.dataset.atPending = 'false';
      state.forEach(({el,label,disabled}) => {el.disabled = disabled;el.textContent = label;});
    }
  }, true);
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-at-cart-open]');
    if (open) {
      event.preventDefault();event.stopImmediatePropagation();
      document.querySelector('[data-rf-drawer]:not([hidden]) [data-rf-close]')?.click();
      openCart();
      try {await refreshCart();} catch (error) {showCartError(error);}
      return;
    }
    if (event.target.closest('[data-at-cart-close]')) {closeCart();return;}
    const step = event.target.closest('[data-at-step]');
    if (step) {
      const input = step.closest('[data-at-quantity]').querySelector('input');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(step.dataset.atStep));
      input.dispatchEvent(new Event('change', {bubbles: true}));return;
    }
    const control = event.target.closest('[data-at-cart-qty]');
    if (control) {
      event.preventDefault();
      if (cartBusy) return;
      cartBusy = true;
      const feedback = dialog()?.querySelector('[data-at-cart-feedback]');
      if (feedback) feedback.textContent = '';
      const line = control.closest('[data-at-line]');
      line?.classList.add('at-busy');
      const focusKey = control.dataset.key;
      const previousQty = Number(control.dataset.atCartQty);
      try {
        const cart = await request('cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: focusKey, quantity: previousQty, sections: sectionNames(), sections_url: root + 'cart'})});
        if (!renderCart(cart.sections)) await refreshCart();
        const buttons = [...(dialog()?.open ? dialog() : document).querySelectorAll('[data-at-cart-qty]')];
        const replacement = buttons.find(el => el.dataset.key === focusKey && Number(el.dataset.atCartQty) !== 0);
        if (replacement) replacement.focus();else if (dialog()?.open) dialog().querySelector('[data-at-cart-close]')?.focus();
      } catch (error) {showCartError(error);} finally {line?.classList.remove('at-busy');cartBusy = false;}
    }
  }, true);
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('[data-at-variant]')) {
      const form = target.closest('form');
      const region = target.closest('[data-at-product]');
      form.querySelector('[data-at-id]').value = target.value;
      region.querySelector('[data-at-price]').textContent = target.dataset.price;
      const compare = region.querySelector('[data-at-compare]');
      compare.textContent = target.dataset.compare;compare.hidden = !target.dataset.compare;
      const available = target.dataset.available === 'true';
      form.querySelectorAll('[type="submit"]').forEach(el => el.disabled = !available);
      form.querySelector('[data-at-add]').textContent = available ? t('add') : t('sold_out');
      form.querySelector('[role="status"]').textContent = '';
      const url = new URL(window.location.href);url.searchParams.set('variant',target.value);history.replaceState({},'',url);
    }
    if (target.matches('[data-at-quantity] input')) target.value = Math.max(1, parseInt(target.value,10) || 1);
    if (target.closest('[data-at-sort]')) target.form.requestSubmit();
  });
  const init = (scope = document) => {
    const el = dialog();
    if (el && !el.dataset.atReady) {
      el.dataset.atReady = 'true';
      el.addEventListener('click', event => {if (event.target === el) {const rect=el.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right)closeCart();}});
      el.addEventListener('close', () => {document.body.classList.remove('at-cart-open');if(cartOpener?.isConnected)cartOpener.focus();});
      el.addEventListener('cancel', () => document.body.classList.remove('at-cart-open'));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
